<template>
  <a-popover
    trigger="click"
    :popup-visible="visible"
    @popup-visible-change="visible = !visible"
    arrow-class="no-show"
    content-class="select"
    position="bl"
  >
    <a-input
      class="mulSearch"
      :class="[margin]"
      :style="{ width: width + 'px' }"
      :placeholder="placeText"
      v-model="checkedList"
      readonly
      allow-clear
      @clear.stop="handleClear"
      :disabled="disabled"
    >
      <template #suffix>
        <icon-down v-show="!visible" />
        <icon-up v-show="visible" />
      </template>
    </a-input>
    <template #content>
      <div>
        <div class="flexColum p5">
          <a-input
            placeholder="搜索内容"
            v-model="searchValue"
            @click="changeList"
            @press-enter="changeList"
            @input="changeList"
            class="mb10"
            allow-clear
          >
            <template #prefix>
              <icon-search />
            </template>
          </a-input>
          <div v-if="selectList.length != 0">
            <a-checkbox
              :model-value="checkedAll"
              :indeterminate="indeterminate"
              @change="handleChangeAll"
            >
              全选
            </a-checkbox>
            <a-checkbox-group
              class="flexColum optionBox"
              v-model="data"
              @change="handleChange"
            >
              <a-checkbox
                class="mb10"
                v-for="item in selectList"
                :key="itemKey ? item[itemKey] : item"
                :value="itemValue ? item[itemValue] : item"
              >
                <div class="selItem">{{ item[itemName] || item }}</div>
              </a-checkbox>
            </a-checkbox-group>
          </div>
          <div v-else class="tips">暂无数据</div>
        </div>
        <div class="footer">
          <a-button size="small" class="mr10" @click="cancel">取消</a-button>
          <a-button size="small" type="primary" @click="handelOk">
            确认
          </a-button>
        </div>
      </div>
    </template>
  </a-popover>
</template>
<script>
  import { onMounted, reactive, toRefs, watch, watchEffect } from 'vue'
  import XEUtils from 'xe-utils'

  export default {
    props: {
      // placeholder
      placeText: {
        type: String,
        default: '搜索',
      },
      // 筛选列表
      list: {
        type: Array,
        default: () => [],
      },
      // key
      itemKey: {
        type: [String, Number],
      },
      // value
      itemValue: {
        type: [String, Number],
      },
      // 要渲染的字段名
      itemName: {
        type: String,
      },
      // 顶部搜索框的宽
      width: {
        type: Number,
        default: 130,
      },
      // 默认选中的数据
      checkedData: {
        type: Array,
        default: () => [],
      },
      // tab是否切换
      changeTab: {
        type: [String, Number, Boolean],
      },
      searchList: {
        type: [String, Array],
      },
      // margin
      margin: {
        type: String,
        default: '',
      },
      // 是否不可操作
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    setup(props, context) {
      const myState = reactive({
        visible: false,
        // 全选
        checkedAll: false,
        indeterminate: false,
        data: props.checkedData,
        // 已选数据
        checkedList: '',
        // 可选列表
        selectList: [],
        // 搜素关键词
        searchValue: '',
        top: null,
        selBox: false,
      })
      watch(
        () => props.list,
        () => {
          myState.selectList = JSON.parse(JSON.stringify(props.list))
        }
      )
      watch(
        () => props.changeTab,
        () => {
          // tab是否切换，切换时清空选中的数据
          myState.indeterminate = false
          myState.checkedAll = false
          myState.searchValue = ''
          myState.checkedList = ''
          myState.data = []
        }
      )
      watchEffect(() => {
        formaChecked()
      })
      onMounted(() => {
        formaChecked()
      })
      // 处理默认选中
      function formaChecked() {
        myState.selectList = XEUtils.clone(props.list, true)
        if (props.checkedData.length > 0) {
          myState.indeterminate = true
          if (props.checkedData.length == props.list.length) {
            myState.checkedAll = true
          }
          let checkedList = []
          const list = XEUtils.clone(props.list, true)
          list.forEach((item) => {
            if (props.checkedData.includes(item[props.itemKey])) {
              checkedList.push(item[props.itemName] || item.name)
            }
          })
          myState.checkedList = checkedList.join()
        }
      }

      // 全选
      const handleChangeAll = (value) => {
        const { list, itemName, itemValue } = props
        myState.indeterminate = false
        if (value) {
          let checkedList = []
          myState.checkedAll = true
          myState.data = list.map((item) => {
            checkedList.push(itemName ? item[itemName] : item)
            return itemValue ? item[itemValue] : item
          })
          myState.checkedList = checkedList.join()
        } else {
          myState.checkedAll = false
          myState.data = []
          myState.checkedList = ''
        }
      }
      // 单选
      const handleChange = (values) => {
        let checkedList = []
        const { list, itemName, itemValue } = props
        if (values.length === list.length) {
          myState.checkedAll = true
          myState.indeterminate = false
          checkedList = list.map((item) => {
            return itemName ? item[itemName] : item
          })
          myState.checkedList = checkedList.join()
        } else if (values.length === 0) {
          myState.checkedAll = false
          myState.indeterminate = false
          myState.checkedList = ''
        } else {
          myState.checkedAll = false
          myState.indeterminate = true
          list.forEach((item) => {
            if (values.includes(itemName ? item[itemValue] : item))
              checkedList.push(itemName ? item[itemName] : item)
          })
          myState.checkedList = checkedList.join()
        }
      }
      // 模糊匹配
      const changeList = () => {
        const { itemName } = props
        const matchList = props.list.filter((item) => {
          return itemName
            ? item[itemName].includes(myState.searchValue)
            : item.includes(myState.searchValue)
        })
        myState.selectList = matchList
      }
      // 清空选择
      function handleClear() {
        myState.indeterminate = false
        myState.data = []
        myState.checkedList = ''
        context.emit('update:searchList', [])
        context.emit('refresh', true)
      }
      // 取消
      const cancel = () => {
        myState.checkedAll = false
        myState.indeterminate = false
        myState.searchValue = ''
        myState.checkedList = ''
        myState.data = []
        myState.visible = false
        context.emit('update:searchList', [])
        context.emit('refresh', true)
      }
      // 确认
      const handelOk = () => {
        myState.visible = false
        context.emit('update:searchList', myState.data)
        context.emit('refresh', true)
      }
      return {
        ...toRefs(myState),
        handleChangeAll,
        handleChange,
        changeList,
        handleClear,
        cancel,
        handelOk,
      }
    },
  }
</script>
<style lang="less" scoped>
  .mulSearch {
    cursor: pointer;
  }
  .optionBox {
    max-height: 300px;
    overflow-y: auto;
    padding-top: 10px;
  }
  .flexColum {
    display: flex;
    flex-direction: column;
  }
  .p5 {
    padding: 5px;
  }
  .optionItem {
    width: 100%;
    overflow: hidden;
  }
  .arco-checkbox {
    white-space: nowrap;
  }
  .footer {
    padding: 5px;
    border-top: 1px solid rgb(231, 230, 230);
    display: flex;
    justify-content: flex-end;
  }
  .tips {
    color: grey;
  }
  .selItem {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
